module.exports = __webpack_public_path__ + "img/08—01—03—Diagnostic information > WLAN.ce69aebb.jpg";